import CloseIcon from '@mui/icons-material/Close';
import { AppBar, Button, CircularProgress, Dialog, DialogContent, Divider, Grid, MenuItem, Modal, Select, TextField, Toolbar, Typography } from '@mui/material';
import { Box, Container, Stack } from '@mui/system';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import {
    endOfMonth,
    endOfQuarter,
    endOfWeek,
    endOfYear,
    startOfMonth,
    startOfQuarter,
    startOfToday,
    startOfWeek,
    startOfYear,
    subMonths,
    subQuarters,
    subWeeks,
    subYears,
} from 'date-fns';
import dayjs from 'dayjs';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'sonner';
import { downloadReport } from '../../redux/Invoice/action';
import { saveFileFromResponse } from '../../utility/helpers/fileDownload';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    // p: 3,
};

const ExportReportModel = ({ open, close }) => {
    const dispatch = useDispatch();
    const [selectedTimePeriod, setSelectedTimePeriod] = useState('');
    const [fromDate, setFromDate] = React.useState(null);
    const [toDate, setToDate] = React.useState(null);
    const [showLoader, setShowLoader] = useState(false);
    const handleClose = () => {
        close(false);
        setFromDate(null);
        setToDate(null);
        setSelectedTimePeriod('');
    };

    const handleChangeTimePeriod = (event) => {
        const selectedType = event.target.value;
        setSelectedTimePeriod(selectedType);

        const today = startOfToday();
        let from = null;
        let to = null;

        switch (selectedType) {
            case 'today':
                from = dayjs(today);
                to = dayjs(today);
                break;
            case 'thisWeek':
                from = dayjs(startOfWeek(today));
                to = dayjs(endOfWeek(today));
                break;
            case 'thisMonth':
                from = dayjs(startOfMonth(today));
                to = dayjs(endOfMonth(today));
                break;
            case 'thisQuarter':
                from = dayjs(startOfQuarter(today));
                to = dayjs(endOfQuarter(today));
                break;
            case 'thisYear':
                from = dayjs(startOfYear(today));
                to = dayjs(endOfYear(today));
                break;
            case 'lastWeek':
                from = dayjs(startOfWeek(subWeeks(today, 1)));
                to = dayjs(endOfWeek(subWeeks(today, 1)));
                break;
            case 'lastMonth':
                from = dayjs(startOfMonth(subMonths(today, 1)));
                to = dayjs(endOfMonth(subMonths(today, 1)));
                break;
            case 'lastQuarter':
                from = dayjs(startOfQuarter(subQuarters(today, 1)));
                to = dayjs(endOfQuarter(subQuarters(today, 1)));
                break;
            case 'lastYear':
                from = dayjs(startOfYear(subYears(today, 1)));
                to = dayjs(endOfYear(subYears(today, 1)));
                break;
            case 'allTime':
                from = dayjs('01/01/2024');
                to = dayjs(today);
                break;
            case 'custom':
                // Allow manual input
                break;
            default:
                from = null;
                to = null;
                break;
        }

        setFromDate(from);
        setToDate(to);
    };
    const handleDownload = async (type) => {
        console.log('type', type, dayjs(fromDate).format('YYYY-MM-DD'), dayjs(toDate).format('YYYY-MM-DD'));
        if ((!fromDate && !toDate) || (dayjs(fromDate).format('YYYY-MM-DD') == 'Invalid Date' && dayjs(toDate).format('YYYY-MM-DD') == 'Invalid Date')) {
            return toast.error('Please enter from date and to date ');
        }
        if (!fromDate || dayjs(fromDate).format('YYYY-MM-DD') == 'Invalid Date') return toast.error('Please enter from date');
        if (!toDate || dayjs(toDate).format('YYYY-MM-DD') == 'Invalid Date') return toast.error('Please enter to date');

        if (fromDate && toDate) {
            setShowLoader(true);
            const payload = {
                // fromDate: toISOStringUTC(fromDate),
                fromDate: dayjs(fromDate).format('YYYY-MM-DD'),
                // toDate: toISOStringUTCEnd(toDate),
                toDate: dayjs(toDate).format('YYYY-MM-DD'),
                format: type,
            };
            const resp = await dispatch(downloadReport(payload));
            setShowLoader(false);
            // on failure the response interceptor has already shown the server's message (no data, PDF failed, timeout)
            if (resp?.status == 200 && saveFileFromResponse(resp, `invoice-sales-report.${type}`)) {
                handleClose();
                toast.success('Invoice sales report exported successfully');
            }
        }
    };
    const disablePrevDates = (toDate) => {
        const startSeconds = Date.parse(toDate);
        return (date) => {
            return Date.parse(date) > startSeconds;
        };
    };
    const disableFutureDates = (toDate) => {
        const startSeconds = Date.parse(toDate);
        return (date) => {
            return Date.parse(date) < startSeconds;
        };
    };
    return (
        <Box>
            <Modal open={open} onClose={handleClose} aria-labelledby="parent-modal-title" aria-describedby="parent-modal-description">
                {/* <form onSubmit={handleSubmit(onSubmit)}> */}
                <Box
                    sx={{
                        ...style,
                        border: 'none',
                        borderRadius: '8px 8px 0px 0px',
                    }}
                    className="modalBodyBoxContainer"
                >
                    <AppBar
                        color="secondary"
                        variant="elevation"
                        sx={{
                            height: '64px',
                            borderRadius: '8px 8px 0px 0px !important',
                            paddingRight: '0px !important',
                        }}
                    >
                        <Toolbar variant="regular">
                            <Typography variant="h6" width={'98%'} color={'white'}>
                                Export Invoices
                            </Typography>
                            <Stack direction={'row'}>
                                <div onClick={handleClose} style={{ cursor: 'pointer', height: '32px' }}>
                                    <CloseIcon sx={{ fill: 'white', fontSize: 32 }} />
                                </div>
                            </Stack>
                        </Toolbar>
                    </AppBar>
                    <Container
                        // gap={2}
                        disableGutters
                        style={{
                            marginTop: '64px',
                        }}
                    >
                        <Grid
                            container
                            // spacing={3}
                            style={{
                                scrollbarColor: 'blue',
                                scrollbarWidth: 'thin',
                                overflowY: 'auto',
                                maxHeight: '78vh',
                            }}
                            padding={'24px 24px 0 24px'}
                        >
                            {/* <hr style={{ width: "100%" }} /> */}
                            {/* <Divider style={{ width: '100%', marginBottom: '24px' }} /> */}
                            <Grid container gap={3}>
                                <Grid md={3.71}>
                                    <Stack>
                                        <div>
                                            <Typography
                                                variant="body1"
                                                style={{
                                                    fontWeight: 500,
                                                    fontSize: '16px',
                                                    lineHeight: '24px',
                                                }}
                                                // padding={"5px"}
                                            >
                                                Select Time Period
                                            </Typography>
                                            <Select
                                                fullWidth
                                                MenuProps={{
                                                    PaperProps: {
                                                        style: {
                                                            maxHeight: 300, // Adjust this value as needed for your design
                                                        },
                                                    },
                                                }}
                                                value={selectedTimePeriod}
                                                onChange={(e) => handleChangeTimePeriod(e)}
                                            >
                                                <MenuItem key={'allTime'} value="allTime">
                                                    All Time
                                                </MenuItem>
                                                <MenuItem key={'custom'} value="custom">
                                                    Custom
                                                </MenuItem>
                                                <MenuItem key={'today'} value="today">
                                                    Today
                                                </MenuItem>{' '}
                                                <MenuItem key={'thisWeek'} value="thisWeek">
                                                    This Week
                                                </MenuItem>{' '}
                                                <MenuItem key={'thisMonth'} value="thisMonth">
                                                    This Month
                                                </MenuItem>{' '}
                                                <MenuItem key={'thisQuarter'} value="thisQuarter">
                                                    This Quarter
                                                </MenuItem>{' '}
                                                <MenuItem key={'thisYear'} value="thisYear">
                                                    This Year
                                                </MenuItem>{' '}
                                                <MenuItem key={'lastWeek'} value="lastWeek">
                                                    Last Week
                                                </MenuItem>
                                                <Divider style={{ width: '100%' }} />
                                                <MenuItem key={'lastMonth'} value="lastMonth">
                                                    Last Month
                                                </MenuItem>
                                                <MenuItem key={'lastQuarter'} value="lastQuarter">
                                                    Last Quarter
                                                </MenuItem>
                                                <MenuItem key={'lastYear'} value="lastYear">
                                                    Last Year
                                                </MenuItem>
                                            </Select>
                                        </div>
                                    </Stack>
                                </Grid>
                                <Grid md={3.71}>
                                    <Stack>
                                        <div>
                                            <Typography
                                                variant="body1"
                                                style={{
                                                    fontWeight: 500,
                                                    fontSize: '16px',
                                                    lineHeight: '24px',
                                                }}
                                                // padding={"5px"}
                                            >
                                                From
                                            </Typography>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DatePicker
                                                    format="DD/MM/YYYY"
                                                    value={fromDate}
                                                    onChange={(newValue) => {
                                                        setFromDate(dayjs(dayjs(newValue).format('YYYY-MM-DD')));
                                                        setSelectedTimePeriod('custom');
                                                    }}
                                                    renderInput={(params) => <TextField {...params} fullWidth />}
                                                    // disabled={selectedTimePeriod !== "custom"}
                                                    shouldDisableDate={disablePrevDates(toDate)}
                                                />
                                            </LocalizationProvider>
                                        </div>{' '}
                                    </Stack>
                                </Grid>
                                <Grid md={3.71}>
                                    <Stack>
                                        <div>
                                            <Typography
                                                variant="body1"
                                                style={{
                                                    fontWeight: 500,
                                                    fontSize: '16px',
                                                    lineHeight: '24px',
                                                }}
                                                // padding={"5px"}
                                            >
                                                To
                                            </Typography>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DatePicker
                                                    format="DD/MM/YYYY"
                                                    value={toDate}
                                                    onChange={(newValue) => {
                                                        setToDate(dayjs(dayjs(newValue).format('YYYY-MM-DD')));
                                                        setSelectedTimePeriod('custom');
                                                    }}
                                                    renderInput={(params) => <TextField {...params} fullWidth />}
                                                    // disabled={selectedTimePeriod !== "custom"}
                                                    shouldDisableDate={disableFutureDates(fromDate)}
                                                />
                                            </LocalizationProvider>
                                        </div>
                                    </Stack>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item container justifyContent={'space-between'} p={3}>
                            <div>
                                <Stack spacing={2} direction="row">
                                    <Button variant="outlined" color="primary" onClick={handleClose}>
                                        CANCEL
                                    </Button>
                                </Stack>
                            </div>

                            <div>
                                <Stack spacing={2} direction="row">
                                    <Button variant="contained" color="primary" onClick={() => handleDownload('pdf')}>
                                        EXPORT PDF
                                    </Button>
                                    <Button variant="contained" color="primary" onClick={() => handleDownload('csv')}>
                                        EXPORT CSV
                                    </Button>
                                </Stack>
                            </div>
                        </Grid>
                    </Container>
                </Box>
                {/* </form> */}
            </Modal>
            <Dialog open={showLoader}>
                <DialogContent>
                    <CircularProgress />
                </DialogContent>
            </Dialog>
        </Box>
    );
};

export default ExportReportModel;
